/**
 * Created by slava on 14.02.17.
 */

cleverapps.CountDownView = cc.Node.extend({
    ctor: function (countDown, style, options = {}) {
        this.style = style || {};

        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.timerEndText = options.timerEndText;

        if (typeof countDown === "number") {
            this.countDown = this.createStaticCountdown(countDown);
        } else {
            this.countDown = countDown;
        }

        let background;
        if (this.style.bar) {
            background = this.createBar();
        } else if (this.style.background_content) {
            background = this.style.background_content;
        } else if (this.style.background) {
            background = cleverapps.UI.createScale9Sprite(this.style.background.frame, cleverapps.UI.Scale9Rect.TwoPixelXY);
            background.setContentSize2(this.style.background.width || background.width, this.style.background.height || background.height);
        }

        if (background) {
            this.background = background;
            background.setCascadeOpacityEnabled(true);
            background.setCascadeColorEnabled(true);
            background.setAnchorPoint(0.5, 0.5);
            background.setAlignment(0, 0);
            this.addChild(background);
        }

        const leftTimeText = this.leftTimeText = new cc.Node();
        leftTimeText.setCascadeOpacityEnabled(true);
        leftTimeText.setCascadeColorEnabled(true);
        leftTimeText.setAnchorPoint(0.5, 0.5);
        this.addChild(leftTimeText);

        this.refresh();

        if (background) {
            leftTimeText.setContentSize(background.width * background.scaleX, background.height * background.scaleY);
        } else if (this.style.dimensions) {
            leftTimeText.setContentSize(this.style.dimensions.width, this.style.dimensions.height);
        } else {
            leftTimeText.setContentSize(this.text.width, this.text.height);
        }

        const leftTimeStyles = this.style.timerPosition || { x: 0, y: 0 };
        leftTimeText.setAlignment(leftTimeStyles.x, leftTimeStyles.y);

        if (this.style.icon) {
            let icon;
            if (this.style.icon.json) {
                icon = new cleverapps.Spine(this.style.icon.json);
                icon.setAnimation(0, this.style.icon.animation, true);
                this.style.icon.stopped && icon.clearTrack(0);
            } else {
                icon = new cc.Sprite(this.style.icon.frame || this.style.icon);
            }

            if (this.style.icon.scale) {
                icon.setScale(this.style.icon.scale);
            }

            const iconWidth = icon.width * icon.scaleX;

            if (background) {
                icon.setAlignment(-background.width / 2 * background.scaleX, 0);
                leftTimeText.setContentSize(background.width * background.scaleX - iconWidth * 0.5, background.height * background.scaleY);
                leftTimeText.setAlignment(leftTimeText.x + iconWidth * 0.25, leftTimeText.y);
            } else {
                icon.setAlignment(-leftTimeText.width / 2, 0);
                leftTimeText.setAlignment(leftTimeText.x + iconWidth * 0.55, leftTimeText.y);
            }

            this.icon = icon;

            this.addChild(icon);
        }

        cleverapps.UI.wrap(this);

        this.updateTextSizeAndPosition();

        this.countDown.onSecond = this.createListener(this.refresh.bind(this));

        if (cleverapps.config.debugMode && options.onSetTimeDebug) {
            cleverapps.UI.onClick(this, () => {
                const input = prompt("Enter the time", "5 seconds");
                if (input) {
                    const time = cleverapps.parseInterval(input);
                    if (!isNaN(time)) {
                        this.countDown.resetTimeLeft(time);
                        options.onSetTimeDebug(time);
                    }
                }
            });
        }
    },

    createBar: function () {
        const bar = this.bar = new ScaledProgressBar({
            type: this.style.bar.type
        });
        bar.setLength(this.style.bar.width);

        const curVal = this.countDown.getTimeLeft();
        bar.setGoal(this.style.bar.fullValue || curVal);
        bar.setPercentage(this.calcBarPercentage(curVal, bar.to));

        return bar;
    },

    calcBarPercentage: function (value, fullValue) {
        return this.style.bar.reversed ? (fullValue - value) : value;
    },

    createStaticCountdown: function (timeLeft) {
        return {
            onSecond: function () {},
            onFinish: function () {},
            getTimeLeft: function () {
                return timeLeft;
            },
            stop: function () {},
            remove: function () {}
        };
    },

    fitTo: function (maxWidth, maxHeight) {
        if (maxWidth === undefined) {
            maxWidth = this.width;
        }

        if (maxHeight === undefined) {
            maxHeight = this.height;
        }

        if (!this.background) {
            const offset = (this.leftTimeText.width - maxWidth) / 2;
            this.leftTimeText.setAlignment(this.leftTimeText.x - offset, this.leftTimeText.y);
        }

        this.leftTimeText.setContentSize2(maxWidth, maxHeight);

        cleverapps.UI.wrap(this);

        this.updateTextSizeAndPosition();
    },

    recreateText: function (string) {
        if (this.text) {
            this.text.removeFromParent(true);
        }

        if (cleverapps.UI.ImageFont.IsApplicable(this.style.font, string)) {
            this.text = new cleverapps.UI.ImageFont(string, this.style.font, { fixedNumberWidth: true });
        } else {
            this.text = cleverapps.UI.generateOnlyText(string, this.style.font);
        }

        this.leftTimeText.addChild(this.text);
    },

    updateTextSizeAndPosition: function () {
        this.text.fitTo(this.leftTimeText.width, this.leftTimeText.height);
        
        this.text.setAnchorPoint(0.5, 0.5);
        this.text.setAlignment(this.leftTimeText.width / 2, this.leftTimeText.height / 2);
    },

    setString: function (string) {
        if (!this.text) {
            this.recreateText(string);
        } else {
            cleverapps.UI.ImageFont.intertypeSetString({
                textObj: this.text,
                string,
                font: this.style.font,
                recreateFunc: this.recreateText.bind(this)
            });
        }

        this.updateTextSizeAndPosition();
    },

    updateBar: function (interval) {
        this.bar.setPercentage(this.calcBarPercentage(this.countDown.getTimeLeft(), this.bar.to), {
            animated: this.bar.to < cleverapps.CountDownView.BAR_ANIMATION_LIMIT,
            time: interval || 1,
            easing: false
        });
    },

    refresh: function (interval) {
        const timeLeft = this.countDown.getTimeLeft();
        let string;

        if (timeLeft <= 0 && this.timerEndText) {
            string = this.timerEndText;
        } else {
            string = cleverapps.intervalToString(this.countDown.getTimeLeft(), this.style.showHours);
        }

        this.setString(string);

        if (this.bar) {
            this.updateBar(interval);
        }
    },

    whatToDoOnStop: function () {
        if (this.countDown.permanent) {
            this.countDown.onSecond = function () {};
        } else {
            this.countDown.remove();
        }
    },

    cleanup: function () {
        this._super();
        this.whatToDoOnStop();
    }
});

cleverapps.CountDown = function (timeLeft, options) {
    this.onSecond = function () {};
    options = options || {};
    this.onFinish = options.onFinish || function () {};
    this.onTick = options.onTick || function () {};

    this.permanent = options.permanent;
    this.ignorePaused = options.ignorePaused;

    this.resetTimeLeft(Math.max(timeLeft, 0));
};

cleverapps.CountDown.prototype.remove = function () {
    if (this.interval !== undefined) {
        cleverapps.CountDownManager.removeListener(this.interval);
    }
    this.interval = undefined;
    this.onFinish = function () {};
    this.onTick = function () {};
    this.onSecond = function () {};
};

cleverapps.CountDown.prototype.stop = function () {
    this.remove();
    this.timeStop = Date.now();
};

cleverapps.CountDown.prototype.isRunning = function () {
    return this.interval !== undefined;
};

cleverapps.CountDown.prototype.getTimeLeft = function () {
    if (!this.timeFinish) {
        return 0;
    }
    if (this.timeStop) {
        return this.timeFinish - this.timeStop;
    }
    return Math.max(this.timeFinish - Date.now(), 0);
};

cleverapps.CountDown.prototype.resetTimeLeft = function (timeLeft) {
    this.timeStart = Date.now();
    this.timeFinish = this.timeStart + timeLeft;

    if (this.interval === undefined) {
        this.interval = cleverapps.CountDownManager.addListener(this);
    }
};

cleverapps.CountDown.prototype.nextSecond = function (now) {
    let timeLeft = this.timeFinish - now;
    if (timeLeft < 0) {
        timeLeft = 0;
    }

    this.onTick(timeLeft);

    this.onSecond(timeLeft);

    if (timeLeft === 0) {
        cleverapps.CountDownManager.removeListener(this.interval);
        this.interval = undefined;
        this.onFinish();
    }
};

cleverapps.Interval = function (callback, interval, options) {
    options = options || {};
    options.onTick = cleverapps.accumulate(interval, callback);

    cleverapps.CountDown.call(this, cleverapps.parseInterval("120 months"), options);
};

cleverapps.Interval.prototype = Object.create(cleverapps.CountDown.prototype);
cleverapps.Interval.prototype.constructor = cleverapps.Interval;

cleverapps.LongTimeout = function (onFinish, timeLeft, options) {
    if (timeLeft <= cleverapps.LongTimeout.THRESHOLD) {
        if (timeLeft < 0) {
            timeLeft = 0;
        }
        this.timeout = cleverapps.timeouts.setTimeout(onFinish, timeLeft);
        return;
    }

    options = options || {};
    options.onFinish = onFinish;
    cleverapps.CountDown.call(this, timeLeft, options);
};

cleverapps.LongTimeout.prototype = Object.create(cleverapps.CountDown.prototype);
cleverapps.LongTimeout.prototype.constructor = cleverapps.LongTimeout;

cleverapps.LongTimeout.prototype.remove = function (...args) {
    if (this.timeout !== undefined) {
        cleverapps.timeouts.clearTimeout(this.timeout);
    } else {
        cleverapps.CountDown.prototype.remove.call(this, ...args);
    }
};

cleverapps.CountDownManager = {
    listeners: {},
    uid: 0,
    interval: false,

    onTick: function () {
        const now = Date.now();
        for (const i in this.listeners) {
            const listener = this.listeners[i];
            if (listener) {
                listener.nextSecond(now);
            }
        }
    },

    addListener: function (listener) {
        const uid = this.uid;
        this.listeners[uid] = listener;

        this.uid++;
        if (this.interval === false) {
            this.interval = cleverapps.timeouts.setInterval(this.onTick.bind(this), cleverapps.CountDown.INTERVAL);
        }

        return uid;
    },

    removeListener: function (uid) {
        delete this.listeners[uid];
    }
};

cleverapps.CountDown.INTERVAL = 1000;
cleverapps.LongTimeout.THRESHOLD = cleverapps.CountDown.INTERVAL;

cleverapps.CountDownView.BAR_ANIMATION_LIMIT = cleverapps.parseInterval("5 minutes");

// eslint-disable-next-line no-global-assign
clearTimeout = cleverapps.extendFunc(clearTimeout, function (timeout) {
    if (timeout instanceof cleverapps.CountDown) {
        timeout.remove();
    } else {
        this._super(timeout);
    }
});

// eslint-disable-next-line no-global-assign
clearInterval = cleverapps.extendFunc(clearInterval, function (interval) {
    if (interval instanceof cleverapps.CountDown) {
        interval.remove();
    } else {
        this._super(interval);
    }
});
